import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { MessagesService } from 'app/layout/common/messages/messages.service';
import { NotificationsService } from 'app/layout/common/notifications/notifications.service';
import { DefaultDataService } from './core/services/default_data/default_data.service';

@Injectable({
    providedIn: 'root'
})
export class InitialDataResolver 
{
    /**
     * Constructor
     */
    constructor(
        private _messagesService: MessagesService,
        private _notificationsService: NotificationsService,
        private _defaultDataService: DefaultDataService
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Use this resolver to resolve initial api for the application
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>
    {
        return this._defaultDataService.getDefaultdata();
        // Fork join multiple API endpoint calls to wait all of them to finish
        // return forkJoin([
        //     this._defaultDataService.getDefaultdata(),
        //     this._messagesService.getAll(),
        //     this._notificationsService.getAll()
        // ]);
    }
}
